const dataRoadmap = [
  {
    id: 1,
    time: "Phase 1",
    list: [
      {
        text: "Building Up Ideas and Plans for Development",
      },
      {
        text: "Building a Website and Community",
      },
      {
        text: "Global Marketing Campaign",
      },
    ],
    positon: "left",
    style: "normal",
  },
  {
    id: 2,
    time: "Phase 2",
    list: [
      {
        text: "Contract Audit",
      },
      {
        text: "KYC Verification",
      },
      {
        text: "Community Events",
      },
    ],
    positon: "right",
    style: "normal",
  },
  {
    id: 3,
    time: "Phase 3",
    list: [
      {
        text: "Pre-Launch Marketing Campaign",
      },
      {
        text: "Release of the Testnet",
      },
      {
        text: "Fixing Bugs Based on User Feedback",
      },
    ],
    positon: "left",
  },
  {
    id: 4,
    time: "Phase 4",
    list: [
      {
        text: "Cooperation with Influencers",
      },
      {
        text: "Calls on Twitter and Degen Channels",
      },
      {
        text: "Fair Launch on Sushiswap",
      },
    ],
    positon: "right",
  },
  {
    id: 5,
    time: "Phase 5",
    list: [
      {
        text: "Trending on Dextools",
      },
      {
        text: "Community Events",
      },
      {
        text: "Advertising on Crypto-Related Websites",
      },
      {
        text: "Listing on Coinmarketcap and Coingecko",
      },
    ],
    positon: "left",
  },
  {
    id: 6,
    time: "Phase 6",
    list: [
      {
        text: "Final Check for the Mainnet Version",
      },
      {
        text: "Cooperation with Arbitrum Partners",
      },
      {
        text: "Release of the Mainnet",
      },
      {
        text: "Update of the New Roadmap",
      },
    ],
    positon: "right",
  },
];

export default dataRoadmap;
